import { HttpContextToken } from '@angular/common/http';

export interface CacheOptions {
    enabled: boolean;
    ttlMs: number;               // z.B. 60_000 = 60s
    staleWhileRevalidate: boolean;
}

export const CACHE_OPTIONS = new HttpContextToken<CacheOptions>(() => ({
    enabled: true, // Caching ist standardmäßig an
    ttlMs: 60_000,
    staleWhileRevalidate: false,
}));

// Hilfsfunktion, um einfache Aktivierung zu kapseln:
export const enableCache = (opts?: Partial<CacheOptions>): CacheOptions => ({
    enabled: true,
    ttlMs: opts?.ttlMs ?? 60_000,
    staleWhileRevalidate: opts?.staleWhileRevalidate ?? false,
});

export const disableCache = (opts?: Partial<CacheOptions>): CacheOptions => ({
    enabled: false,
    ttlMs: opts?.ttlMs ?? 60_000,
    staleWhileRevalidate: opts?.staleWhileRevalidate ?? false,
});
